import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import {Link} from 'react-router-dom';

class PremierGardenCareGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      premiergardencareGallerypage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "premiergardencareGallery",
      //'order': 'sys.createdAt'
    }).then((entries) => {
      this.setState({ premiergardencareGallerypage: entries.items});
    });
  }

  redirectToTarget=()=>{
    this.props.history.push('/premier-garden-care')
  }


  render() {
    return (
      <>
      <div className="container-fluid text-left">
        <h1>PREMIER GARDEN CARE GALLERY</h1>
      </div>
      <div>
        {this.state.premiergardencareGallerypage.length === 0 ?
          <div><img src={BlackLoading} alt="Loading..." /></div> :
              <div className="grid">
                  {this.state.premiergardencareGallerypage.map((item, num=0) => {
                      num = num + 1
                      return (
                          <div key={num} className="col-md-4 col-12">
                              <input type="checkbox" id={num} />
                              <label htmlFor={num} className="lightbox"><img src={item.fields.premiergardencareGalleryPhoto.fields.file.url} alt="sam bridge premier garden care photos" /></label>
                              <label htmlFor={num}><img src={item.fields.premiergardencareGalleryPhoto.fields.file.url} alt="sam bridge premier garden care photos" /></label>
                              {/* <p className="text-center">{item.fields.premiergardencareGalleryTitle}</p> */}
                          </div>
                      )
                  })}
            </div>
      }

      </div>
      <div className="container-fluid">
      <p><Link to="#" onClick={this.redirectToTarget}><button className="btn btn-primary">Back to Premier Garden Care</button></Link></p>
      </div>
    </>
    );
  }
}

export default PremierGardenCareGallery;
